import { CalculationConfig } from '@calculations/types/calculation-config';
import { PriceStrategySnapWorkOrder } from '@snap-types/transforms/price-strategy/shared';

import { QuoteBuilderOperationType } from '../../types/state/operation';
import { QuoteBuilderRequirementType } from '../../types/state/requirement';
import { transformSnapRequirementToStoreState } from './transform-requirement';

export function transformSnapOperationToStoreState(
  operation: PriceStrategySnapWorkOrder['snapOperations'][number],
  calculationConfig: CalculationConfig,
): { uuid: string; operation: QuoteBuilderOperationType } {
  const requirementUuids: string[] = [];
  const snapRequirements: Record<string, QuoteBuilderRequirementType> = {};

  for (const snapRequirement of operation.snapRequirements) {
    const { uuid, requirement } = transformSnapRequirementToStoreState(
      snapRequirement,
      calculationConfig,
    );
    requirementUuids.push(uuid);
    snapRequirements[uuid] = requirement;
  }

  return {
    uuid: operation.uuid,
    operation: {
      uuid: operation.uuid,
      sequenceNo: operation.sequenceNo,
      resourceId: operation.resourceId,
      run:
        operation.run?.toDecimalPlaces(calculationConfig.decimalPlaces) ?? null,
      runType: operation.runType,
      loadSizeQty:
        operation.loadSizeQty?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? null,
      setupCostPerHr:
        operation.setupCostPerHr?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? null,
      runCostPerHr:
        operation.runCostPerHr?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? null,
      runCostPerUnit:
        operation.runCostPerUnit?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? null,
      serviceBaseCharge:
        operation.serviceBaseCharge?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? null,
      serviceMinCharge:
        operation.serviceMinCharge?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? null,
      serviceChargePerUnit:
        operation.serviceChargePerUnit?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? null,
      burPerHrSetup:
        operation.burPerHrSetup?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? null,
      burPerHrRun:
        operation.burPerHrRun?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? null,
      burPerUnitRun:
        operation.burPerUnitRun?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? null,
      setupHrs:
        operation.setupHrs?.toDecimalPlaces(calculationConfig.decimalPlaces) ??
        null,
      serviceId: operation.serviceId ?? null,
      burPercentRun:
        operation.burPercentRun?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? null,
      burPercentSetup:
        operation.burPercentSetup?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? null,
      scrapYieldPct:
        operation.scrapYieldPct?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? null,
      fixedScrapUnits:
        operation.fixedScrapUnits?.toDecimalPlaces(
          calculationConfig.decimalPlaces,
        ) ?? null,
      scrapYieldType: operation.scrapYieldType,

      documents: operation.documents,

      snapRequirementUuids: requirementUuids,
      snapRequirements,
    },
  };
}
